import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
// Consistent app-wide date/number formatting.
// Locale fixed to en-GB (dd/mm/yyyy) and timezone to Asia/Jerusalem.
const TZ = 'Asia/Jerusalem';
const LOCALE = 'en-GB';

export function formatDate(date: string | number | Date) {
  return new Date(date).toLocaleDateString(LOCALE, {
    timeZone: TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTime(date: string | number | Date) {
  return new Date(date).toLocaleString(LOCALE, {
    timeZone: TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatNumber(value: number) {
  return value.toLocaleString(LOCALE);
}

/**
 * The single placeholder for "there is no value here" — an em dash, which is
 * what the rest of the app already renders. A plain hyphen reads as a minus
 * sign next to numbers, and mixing the two made two panels showing the same
 * missing reading look like they meant different things.
 */
export const NO_VALUE = '—';

/**
 * A number with thousands separators and a fixed number of decimals. Reading
 * values reach the thousands in ppm, where an ungrouped "4321.0" is genuinely
 * hard to read at a glance.
 */
export function formatDecimal(value: number, digits = 1) {
  return value.toLocaleString(LOCALE, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

/** Sensor metric with its unit, grouped, one decimal. Renders NO_VALUE when there is no reading. */
export function formatMetric(value: number | null | undefined, unit: string, digits = 1) {
  return value == null || Number.isNaN(value) ? NO_VALUE : `${formatDecimal(value, digits)}${unit}`;
}